import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'src/Routes';

import './App.css';
import { Global } from '@emotion/react';

const GlobalStyle = () => {
  return (
    <Global
      styles={{
        '*': {
          boxSizing: 'border-box',
          margin: 0,
          padding: 0,
        },
        html: {
          '-webkit-font-smoothing': 'antialiased',
          '-moz-osx-font-smoothing': 'grayscale',
          height: '100%',
          width: '100%',
        },
        body: {
          height: '100%',
          width: '100%',
        },
        '#root': {
          height: '100%',
          width: '100%',
        },
        a: {
          textDecoration: 'none',
        },
      }}
    />
  );
};

const App: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <BrowserRouter basename={'/'}>
        <Routes />
      </BrowserRouter>
    </>
  );
};

export default App;
